export default __webpack_public_path__ + "SampleProductSheet.xlsx";